import React from 'react'

const Asia2022 = () => {
  return (
    <div>
        Asia 2022 - COMING SOON
    </div>
  )
}

export default Asia2022